import Helper from './Helper';

class CV {
  constructor(config = {}) {
    const {
      trigger
    } = config;
    this.trigger = trigger;
    this.triggers = Array.prototype.slice.call(document.querySelectorAll(this.trigger));

    this.currentEl = null;
    if(this.triggers && this.triggers.length !== 0){
      this.bindEvents();
    }
  }

  bindEvents() {
    this.triggers.forEach(el => {
      el.addEventListener('click', (e) => {
        Helper.toggleClass(el.parentElement, 'mobile-open');
      });
    });
  }
}

export default CV;
